import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { FiCheck, FiX, FiTrash2, FiStar } from 'react-icons/fi';
import AdminLayout from '../../components/layout/AdminLayout';
import api from '../../utils/api';

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

export default function AdminTestimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [filter, setFilter] = useState('all');

  const load = () => api.get('/testimonials/admin/all').then(r=>setTestimonials(r.data)).catch(()=>{});
  useEffect(()=>{ load(); },[]);

  const updateStatus = async (id, status) => {
    try { await api.put(`/testimonials/${id}`, { status }); toast.success(`Testimonial ${status}`); load(); }
    catch { toast.error('Failed'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete?')) return;
    try { await api.delete(`/testimonials/${id}`); toast.success('Deleted'); load(); }
    catch { toast.error('Failed'); }
  };

  const filtered = filter==='all' ? testimonials : testimonials.filter(t=>t.status===filter);
  const counts = { all:testimonials.length, pending:testimonials.filter(t=>t.status==='pending').length, approved:testimonials.filter(t=>t.status==='approved').length, rejected:testimonials.filter(t=>t.status==='rejected').length };

  return (
    <AdminLayout title="Manage Testimonials">
      <div style={{ maxWidth:900 }}>
        <div style={{ display:'flex', gap:'0.5rem', marginBottom:'1.5rem', background:'white', padding:'0.4rem', borderRadius:'12px', width:'fit-content', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', border:'1px solid #F3F4F6' }}>
          {[['all','All'],['pending','Pending'],['approved','Approved'],['rejected','Rejected']].map(([val,label])=>(
            <button key={val} onClick={()=>setFilter(val)} style={{ padding:'0.45rem 1rem', borderRadius:'8px', border:'none', background:filter===val?'var(--navy)':'transparent', color:filter===val?'white':'var(--gray-500)', fontWeight:filter===val?600:400, fontSize:'0.82rem', cursor:'pointer', transition:'all 0.2s', fontFamily:'Outfit,sans-serif' }}>
              {label} <span style={{ marginLeft:'0.2rem', background:filter===val?'rgba(255,255,255,0.2)':'var(--gray-100)', color:filter===val?'white':'var(--gray-500)', borderRadius:'10px', padding:'0.1rem 0.4rem', fontSize:'0.73rem' }}>{counts[val]}</span>
            </button>
          ))}
        </div>

        {filtered.length===0 ? (
          <div style={{ background:'white', borderRadius:'16px', padding:'4rem', textAlign:'center', color:'var(--gray-400)' }}><div style={{ fontSize:'3rem', marginBottom:'1rem' }}>💬</div><p>No {filter!=='all'?filter:''} testimonials.</p></div>
        ) : (
          <div style={{ display:'flex', flexDirection:'column', gap:'0.75rem' }}>
            {filtered.map(t=>(
              <div key={t.id} style={{ background:'white', borderRadius:'14px', padding:'1.5rem', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', border:`1.5px solid ${t.status==='pending'?'#FCD34D':t.status==='approved'?'#6EE7B7':'#FCA5A5'}` }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:'1rem', flexWrap:'wrap' }}>
                  <div style={{ display:'flex', gap:'1rem', flex:1 }}>
                    {t.profile_image?<img src={`${BACKEND}${t.profile_image}`} alt={t.full_name} style={{ width:52, height:52, borderRadius:'50%', objectFit:'cover', flexShrink:0 }}/>
                      :<div style={{ width:52, height:52, borderRadius:'50%', background:'var(--navy)', display:'flex', alignItems:'center', justifyContent:'center', color:'#C9A84C', fontFamily:'Fraunces,serif', fontWeight:700, fontSize:'1.2rem', flexShrink:0 }}>{t.full_name?.[0]}</div>}
                    <div style={{ flex:1 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:'0.75rem', marginBottom:'0.25rem', flexWrap:'wrap' }}>
                        <strong style={{ color:'var(--navy)', fontSize:'0.9rem' }}>{t.full_name}</strong>
                        <span className={`badge badge-${t.status}`}>{t.status}</span>
                      </div>
                      <div style={{ color:'var(--gray-400)', fontSize:'0.78rem', marginBottom:'0.4rem' }}>{t.position}{t.position&&t.company?' · ':''}{t.company}</div>
                      <div style={{ display:'flex', gap:'2px', marginBottom:'0.6rem' }}>
                        {[...Array(t.rating||5)].map((_,j)=><FiStar key={j} style={{ color:'#C9A84C', fill:'#C9A84C', fontSize:'0.8rem' }}/>)}
                      </div>
                      <p style={{ color:'var(--gray-600)', fontSize:'0.875rem', lineHeight:1.7, fontStyle:'italic' }}>"{t.text}"</p>
                      <p style={{ color:'var(--gray-300)', fontSize:'0.73rem', marginTop:'0.4rem' }}>{new Date(t.created_at).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'})}</p>
                    </div>
                  </div>
                  <div style={{ display:'flex', gap:'0.5rem', flexShrink:0 }}>
                    {t.status!=='approved'&&<button onClick={()=>updateStatus(t.id,'approved')} style={{ padding:'0.45rem 0.85rem', borderRadius:'8px', background:'#DCFCE7', color:'#166534', border:'none', cursor:'pointer', fontSize:'0.82rem', display:'flex', alignItems:'center', gap:'0.3rem' }}><FiCheck/>Approve</button>}
                    {t.status!=='rejected'&&<button onClick={()=>updateStatus(t.id,'rejected')} style={{ padding:'0.45rem 0.85rem', borderRadius:'8px', background:'#FEF9C3', color:'#854D0E', border:'none', cursor:'pointer', fontSize:'0.82rem', display:'flex', alignItems:'center', gap:'0.3rem' }}><FiX/>Reject</button>}
                    <button onClick={()=>handleDelete(t.id)} style={{ padding:'0.45rem 0.65rem', borderRadius:'8px', background:'#FEE2E2', color:'#991B1B', border:'none', cursor:'pointer', fontSize:'0.85rem' }}><FiTrash2/></button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
